const { getElements } = window.BAO.Utils

if (!customElements.get('quick-add-opener')) {
  customElements.define('quick-add-opener', class QuickAddOpener extends HTMLElement {
    connectedCallback () {
      this.addEventListener('click', () => {
        this.show(this.querySelector('button'))
      })
    }

    show (opener) {
      document.querySelectorAll('quick-add-modal[open]').forEach((modal) => {
        if (typeof modal.hide === 'function') modal.hide(true)
      })

      const url = new URL(window.location.origin + opener.getAttribute('data-product-url'))
      url.searchParams.set('view', 'quick-add')
      let quickAddModalEl = null

      opener.setAttribute('aria-disabled', true)
      opener.classList.add('loading')

      fetch(url.toString())
        .then((response) => response.text())
        .then((responseText) => {
          quickAddModalEl = new DOMParser().parseFromString(responseText, 'text/html').querySelector('quick-add-modal')

          if (!quickAddModalEl) return
          document.body.append(quickAddModalEl)
        })
        .catch((error) => {
          console.error(error)
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled')
          opener.classList.remove('loading')

          if (quickAddModalEl && typeof quickAddModalEl.show === 'function') {
            quickAddModalEl.show(opener)
          }

          this.handleCustomTracking()
        })
    }

    handleCustomTracking() {
      const trackingPlacement = this.closest('[data-gtm-el]')

      if (!trackingPlacement) return

      window.dataLayer = window.dataLayer || []

      const trackingPlacementName = trackingPlacement.getAttribute('data-gtm-el')
      window.sessionStorage.setItem('BAO-gtm-event-context--quick-add', trackingPlacementName)

      if (trackingPlacementName === 'hotspot') {
        this.trackHotspotClicks()
      }
    }

    trackHotspotClicks() {
      const targetContextEl = this.closest('[data-gtm-target-context]')
      const targetContext = targetContextEl ? targetContextEl.getAttribute('data-gtm-target-context') : ''

      const parameters = {
        target_context: targetContext
      }

      window.BAO.Utils.pushToDataLayer('hotspot_click', parameters)
    }
  })
}

if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor () {
      super()
      this.dialog = this.querySelector('dialog.quick-add-modal__content')
      this.modalImages = this.querySelector('[id^="QuickAddInfo-"] .quick-add-modal__media')
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"] .quick-add-modal__details')
      this.onDialogKeydown = this.onDialogKeydown.bind(this)
      if (this.dialog) {
        this.dialog.addEventListener('cancel', (event) => {
          event.preventDefault()
          this.hide()
        })
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.hide()
        })
        this.dialog.addEventListener('keydown', this.onDialogKeydown)
      }
    }

    hide (preventFocus = false) {
      document.body.classList.remove('overflow-hidden', 'quickbuy-open')
      document.body.dispatchEvent(new CustomEvent('modalClosed'))
      this.removeAttribute('open')
      if (this.dialog?.open) {
        this.dialog.close()
      }
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer')
      if (cartNotification) cartNotification.setActiveElement(this.openedBy)
      this.modalContent.innerHTML = ''

      if (!preventFocus && this.openedBy && typeof this.openedBy.focus === 'function') {
        this.openedBy.focus()
      }
      if (preventFocus) this.openedBy = null
      this.remove()

      window.sessionStorage.removeItem('BAO-gtm-event-context--quick-add')
    }

    show (opener) {
      opener.setAttribute('aria-disabled', true)
      opener.classList.add('loading')

      let didOpen = false

      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html')
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]')
          this.productImages = responseHTML.querySelector('section.prd-Media .prd-Media_Slides')

          if (!this.productElement || !this.productImages) {
            const productUrl = opener.getAttribute('data-product-url')
            if (productUrl) window.location.href = productUrl
            return
          }

          this.preventDuplicatedIDs()
          this.removeDOMElements()
          this.setMoreInPrintSlidesPerView()
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML)
          this.setInnerHTML(this.modalImages, this.productImages.innerHTML)
          this.overrideFormTargetContext()

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init()
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR()

          this.updateImageSizes()
          this.openedBy = opener
          document.body.classList.add('overflow-hidden')
          this.setAttribute('open', '')
          if (this.dialog?.showModal) {
            this.dialog.showModal()
          } else {
            this.dialog?.setAttribute('open', '')
          }
          window.pauseAllMedia()
          this.createSlider()
          this.preventVariantURLSwitching()

          setTimeout(() => {
            window.dispatchEvent(new Event('resize'))
          })

          didOpen = true
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled')
          opener.classList.remove('loading')

          if (!didOpen) {
            this.remove()
            return
          }

          if (window.klaviyoBIS) {
            window.klaviyoBIS()
          }

          setTimeout(() => { this.testForSticky() }, 100)
          window.addEventListener('resize', () => { this.testForSticky() })

          document.body.classList.add('quickbuy-open')
          window.dispatchEvent(new CustomEvent('quick-add:open'))
        })
    }

    setInnerHTML (element, html) {
      element.innerHTML = html
      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script')
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        })
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML))
      })
    }

    preventVariantURLSwitching () {
      const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects')
      if (!variantPicker) return
      variantPicker.setAttribute('data-update-url', 'false')
    }

    overrideFormTargetContext () {
      const addToCartForm = this.modalContent.querySelector('form[data-type="add-to-cart-form"]')
      if (!addToCartForm) return
      addToCartForm.setAttribute('data-gtm-target-context', 'quick-buy-form')
    }

    removeDOMElements () {
      const productModal = this.productElement.querySelector('product-modal')
      if (productModal) productModal.remove()
    }

    setMoreInPrintSlidesPerView () {
      const carousel = this.productElement.querySelector('.prd-MoreInPrint-mobile bao-more-in-print-carousel')
      if (carousel) carousel.setAttribute('data-slides-per-view', '2')
    }

    preventDuplicatedIDs () {
      if (!this.productElement?.dataset?.section) return

      const sectionId = this.productElement.dataset.section
      const uniquePrefix = `quickadd-${sectionId}`

      this.dataset.uniquePrefix = uniquePrefix
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, uniquePrefix)
      // Bundle component radios use global ids (`value-{id}`) and names (`{componentId}-size`).
      // When a sibling set reuses the PDP bottoms product those collide and labels hit the page inputs.
      this.constructor.uniquifyDomIds(this.productElement, uniquePrefix)
      this.productElement.querySelectorAll('variant-selects, variant-radios, set-variant-radios').forEach((variantSelect) => {
        variantSelect.dataset.originalSection = sectionId
      })
    }

    /**
     * Prefix ids, label `for`s, and radio `name`s under `root` so they don't collide with the PDP.
     * @param {ParentNode} root
     * @param {string} uniquePrefix
     */
    static uniquifyDomIds (root, uniquePrefix) {
      if (!root || !uniquePrefix) return

      root.querySelectorAll('[id]').forEach((el) => {
        // SVG nodes can expose `id` as SVGAnimatedString — always read the attribute string.
        const oldId = el.getAttribute('id')
        if (!oldId || oldId.includes(uniquePrefix)) return

        const newId = `${uniquePrefix}-${oldId}`
        el.setAttribute('id', newId)

        root.querySelectorAll(`[for="${CSS.escape(oldId)}"]`).forEach((label) => {
          label.setAttribute('for', newId)
        })

        // Inputs outside the product form (e.g. bundle `_bundle_components`) join it via `form="{id}"`.
        root.querySelectorAll(`[form="${CSS.escape(oldId)}"]`).forEach((field) => {
          field.setAttribute('form', newId)
        })
      })

      root.querySelectorAll('input[type="radio"][name]').forEach((el) => {
        const name = el.getAttribute('name')
        if (!name || name.includes(uniquePrefix)) return
        el.dataset.originalName = name
        el.setAttribute('name', `${uniquePrefix}-${name}`)
      })
    }

    createSlider () {
      if (!this.modalImages) return
      if (this.keenSlider && typeof this.keenSlider.destroy === 'function') {
        this.keenSlider.destroy()
      }

      function navigation (slider) {
        let dots

        function createDiv (className) {
          const div = document.createElement('div')
          const classNames = className.split(' ')
          classNames.forEach((name) => div.classList.add(name))
          return div
        }

        function dotMarkup () {
          dots = createDiv('dots')
          dots.setAttribute('role', 'tablist')
          dots.setAttribute('aria-label', 'Product image carousel')
          slider.track.details.slides.forEach((_e, idx) => {
            const dot = createDiv('dot')
            dot.setAttribute('role', 'tab')
            dot.setAttribute('tabindex', idx === 0 ? '0' : '-1')
            dot.setAttribute('aria-label', `Image ${idx + 1} of ${slider.track.details.slides.length}`)
            dot.setAttribute('aria-selected', idx === 0 ? 'true' : 'false')
            dot.addEventListener('click', () => slider.moveToIdx(idx))
            dot.addEventListener('keydown', (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault()
                slider.moveToIdx(idx)
              }
            })
            dots.appendChild(dot)
          })
          slider.container.prepend(dots)
        }

        function updateClasses () {
          const slide = slider.track.details.rel
          Array.from(dots.children).forEach(function (dot, idx) {
            idx === slide
              ? dot.classList.add('dot--active')
              : dot.classList.remove('dot--active')
            dot.setAttribute('tabindex', idx === slide ? '0' : '-1')
            dot.setAttribute('aria-selected', idx === slide ? 'true' : 'false')
          })
        }

        slider.on('created', () => {
          dotMarkup()
          updateClasses()
        })
        slider.on('optionsChanged', () => {
          updateClasses()
        })
        slider.on('slideChanged', () => {
          updateClasses()
        })
      }

      const slider = new window.KeenSlider(
        this.modalImages,
        {
          loop: true,
          initial: this.productImages?.children?.length ? this.productImages.children.length - 1 : 0,
          mode: 'snap',
          slides: {
            perView: 1,
            spacing: 0,
          },
        },
        [
          navigation,
        ],
      )
      this.keenSlider = slider

      requestAnimationFrame(() => {
        if (this.keenSlider && typeof this.keenSlider.update === 'function') {
          this.keenSlider.update()
        }
      })

      window.BAO.eventBus.addEventListener(window.BAO.EVENTS.BUNDLE_COMPONENT.OPTION_SELECTED, (event) => {
        const slideIndex = slider?.slides?.find(el => el.dataset?.galleryImageHandle?.includes(event.detail?.value))?.dataset?.slide
        if (!slideIndex && slideIndex !== 0) return

        slider.moveToIdx(Number(slideIndex))
      })
    }

    onDialogKeydown (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return
      const active = document.activeElement
      const isTextControl = active && (
        active.tagName === 'INPUT' ||
        active.tagName === 'TEXTAREA' ||
        active.isContentEditable
      )
      if (isTextControl || !this.keenSlider) return
      e.preventDefault()
      if (e.key === 'ArrowLeft') this.keenSlider.prev()
      else this.keenSlider.next()
    }

    updateImageSizes () {
      const product = this.modalImages
      const mediaImages = product.querySelectorAll('.rsp-Image_Image')
      if (!mediaImages.length) return
      const mediaImageSizes = '(max-width: 749px) 100vw, 33vw'
      mediaImages.forEach(img => img.setAttribute('sizes', mediaImageSizes))
    }

    testForSticky () {
      const scrollableDiv = this.querySelector('.quick-add-modal__details')
      const stickyButtons = this.querySelector('.prd-BuyButtons')

      if (!scrollableDiv || !stickyButtons) return

      const buttonsStuck = scrollableDiv.scrollHeight > (scrollableDiv.clientHeight + 2)

      if (buttonsStuck) {
        stickyButtons.classList.add('container-stuck')
      } else {
        stickyButtons.classList.remove('container-stuck')
      }
    }
  })
}

if (!customElements.get('cdm-modal-opener')) {
  customElements.define('cdm-modal-opener', class CdmModalOpener extends HTMLElement {
    connectedCallback () {
      this.trigger = this.querySelector('[data-cdm-modal-el="trigger"]')
      this.modal = this.querySelector('[data-cdm-modal-el="modal"]')
      this.close = this.querySelector('[data-cdm-modal-el="close"]')

      this.addEventListener('click', () => {
        this.modalClick()
      })

      this.trigger.addEventListener('click', () => {
        this.showModal()
      })

      this.close.addEventListener('click', () => {
        this.closeModal()
      })
    }

    showModal () {
      this.trigger.setAttribute('aria-disabled', true)
      this.trigger.classList.add('loading')

      this.dataset.modalOpen = 'true'
      this.modal.style.display = 'flex'
      this.trigger.style.opacity = 0.5

      this.trigger.removeAttribute('aria-disabled')
      this.trigger.classList.remove('loading')
    }

    closeModal () {
      this.dataset.modalOpen = 'false'
      this.modal.style.display = 'none'
      this.trigger.style.opacity = 1
    }

    modalClick () {
      if (this.dataset.modalOpen === 'false') return

      const modalBox = event.target.closest('.cdm-Modal_Box')

      if (!event.target.classList.contains('quick-add__submit') && modalBox === null) {
        this.closeModal()
      }
    }
  })
}
